$(document).ready(function () {
  var err_bg_color = "#FFE0E0";

  $("button[type='submit'][name='add']").click(function () {
    var err = "";
    var ret = true;
    if (($("#roadside-card-number").length > 0) && //check the element exists
      ($('input[name="ra-card-rd"]:checked').val() == "Yes" || $('[name=ct_purchase_select]').val() != "No") &&
      ($('#roadside-card-number').is(':disabled') || processVerifyCard() == false)) {
      if ($('input[name="ra-card-rd"]:checked').val() != "Yes")
        $("input[name='ra-card-rd'][value='Yes']").prop('checked', true).trigger('change');
      if ($('[name=ct_purchase_select]').val() != "No")
        $('[name=ct_purchase_select]').val("No").trigger('change');
      $(document).scrollTop($("#id-prod-top").offset().top);
      return false;
    }
    var promo = $.trim($('#promotional-code').val().toLowerCase());
    //if($('#promotional-code').prop('required') && $. trim($('#promotional-code').val()).length==0) {
    if ($('#promotional-code').prop('required') && promo != 'triangle') {
      $(document).scrollTop($("#id-prod-top").offset().top);
      if (promo.length == 0)
        $(".ra-promo-error").html(ra_lang_rc.promo_code_required);
      else
        $(".ra-promo-error").html(ra_lang_rc.invalid_promo_code);
      $(".ra-promo-error").show();
      //document.getElementById("promotional-code").classList.add("err-bg-color");
      document.getElementById("promotional-code").style.backgroundColor = err_bg_color;
      document.getElementById("promotional-code").focus();
      return false;
    }

    var inputs = $(".prim_member_elm1, .extra_member_elm2:not(:disabled), .extra_member_elm3:not(:disabled), .extra_member_elm4:not(:disabled), .extra_member_elm5:not(:disabled), .extra_member_elm6:not(:disabled), .extra_member_elm7:not(:disabled), .extra_member_elm8:not(:disabled), .extra_member_elm9:not(:disabled), .extra_member_elm10:not(:disabled), .extra_member_elm11:not(:disabled)");
    $(".ra-member-info-error").hide();
    $.each(inputs, function (key, elm) {
      if (elm.dataset.title == "hidden-info")
        return;

      if (elm.required) {
        if (elm.value == '') {
          err = elm.dataset.title + ra_lang_rc.required;
          ret = false;
        } else {
          err = ctCheckInput(elm)
          if (err != "")
            ret = false;
        }
      } else if (elm.value != '') {
        err = ctCheckInput(elm)
        if (err != "")
          ret = false;
      }

      if (!ret) {
        $(".ra-member-info-error").children('.err-msg').text(err);
        $(".ra-member-info-error").show();
        //elm.classList.add("err-bg-color");
        elm.style.backgroundColor = err_bg_color;
        if (elm.tagName == 'INPUT')
          elm.select();
        elm.focus();

        //open hidden div if it failed to validate its input.
        var idx = elm.dataset.index;
        if (idx != undefined) {
          var obj = $("#addition-member-icon-" + idx);
          if (!obj.find(".ra-icon-plus").hasClass("ra-display-none")) {
            obj.trigger("click");
          }
        }

        return false;
      } else {
        var tri_val = $.trim($("input[name=triangle-number]").val());
        if (tri_val.length > 0)
          $("#triangle-number-prop").val($("#triangle-prefilled").text() + tri_val);
        else
          $("#triangle-number-prop").val('');
      }
    });

    if (ret && $('#chk-terms-conditions').is(':checked') == false) {
      $(".ra-terms-error").show();
      ret = false;
    }

    if (ret && $('[name=ct_plan_members]').val() == 1 && push4more) {
      $('#ct-member-number-popup .ct-extra-number').text($('#ct-member-number .ct-extra-number').text());
      $('#popup-container').show();
      return false;
    }

    return ret;
  });

  $("#ct-popup-btn-yes, #ct-popup-btn-no, #ct-popup-btn-close").click(function (event) {
    event.preventDefault();
    $('#popup-container').hide();
    if ($(this).attr('id') == "ct-popup-btn-yes") {
      push4more = false;
      var second_member = $(".extra_member_info[data-index='2'] .ra-member-info-bar-ex");
      if (second_member.length > 0) {
        if (!second_member.hasClass('ra-bar-bg-color'))
          second_member.trigger('click');
      }
      $('html, body').animate({
        scrollTop: $("#div-addition-member-2").offset().top - 150
      }, 1000);
    } else if ($(this).attr('id') == "ct-popup-btn-no") {
      push4more = false;
      $("input[name='ct_plan_members']").val(1).trigger('change');
      setTimeout(function () {
        $("button[type='submit'][name='add']").trigger("click");
      }, 100);
    } else if ($(this).attr('id') == "ct-popup-btn-close" && $(".ct-extra-number").text() > 0) {
      $(".ct-extra-number").text(0);
      $("input[name='ct_plan_members']").val(1).trigger('change');
    }
  });
  $("#ct-member-number .ct-circle-btn, #ct-member-number-popup .ct-circle-btn").click(function (event) {
    event.preventDefault();
    var num = parseInt($("input[name='ct_plan_members']").val());
    var num_max = parseInt($("#ct_plan_member_max").text());
    console.log(num)
    if ($(this).hasClass('ct-circle-btn-minus')) {
      if (num > 1)
        num--;
    } else {
      if (num < num_max)
        num++;
    }
    if ($(".ct-extra-number[data-is-family='true']").length > 0){
      $(".ct-extra-number").text(num);
    }
    else {
      $(".ct-extra-number").text(num - 1);
    }
      
    $("input[name='ct_plan_members']").val(num).trigger('change');
  });

  $('[name=ct_plan_members]').on('change', function (e) {
    var num = $(this).val();

    $("#selected_number").text(num);
    $(".ra-member-info-error").hide();
    $('.extra_member_info').each(function (i, obj) {
      var elms = $(".extra_member_elm" + (i + 2));
      if (i < num - 1) {
        obj.style.display = "block";
        ctSetElementRequired(elms, true);
      } else {
        obj.style.display = "none";
        ctSetElementRequired(elms, false);
      }
    });

    setTimeout(updateAdditionalMemberPrice, 100);
  });

  function updateAdditionalMemberPrice() {
    var price = $.trim($('#ProductPrice-' + prod_section_id).text()).replace('$', '');
    var first_price = $.trim($('#ct_first_variant_price').text()).replace('$', '');

    $('.ct-extra-number-price').text('$' + (price - first_price).toFixed(2))
  }

  $("#promotional-code").keydown(function () {
    $(".ra-promo-error").hide();
    //this.classList.remove("err-bg-color");
    this.style.backgroundColor = "";
  });

  $("input[type='text']").keydown(function () {
    $(".ra-member-info-error").hide();
    //this.classList.remove("err-bg-color");
    this.style.backgroundColor = "";
  });

  $("#ra_member_province").change(function () {
    $(".ra-member-info-error").hide();
    //this.classList.remove("err-bg-color");
    this.style.backgroundColor = "";
  });

  $('input[name="ra-card-rd"]').change(function () {
    $("#roadside-card-number").val('');
    $("#ra-card-number-error").hide();
    document.getElementById("roadside-card-number").style.backgroundColor = "";
    if (this.value == 'Yes') {
      $("#checkcard-wrap").show();
      $("#roadside-card-number").prop('disabled', false);
      $("#roadside-card-number").prop('required', true);
    } else if (this.value == 'No') {
      $("#checkcard-wrap").hide();
      $("#roadside-card-number").prop('disabled', true);
      $("#roadside-card-number").prop('required', false);
      if ($('[name=ct_purchase_select]').val() != "No")
        $('[name=ct_purchase_select]').val("No").trigger('change');
    }
  });

  $("#btn-checkcard").click(function () {
    processVerifyCard();
    return false;
  });

  $("#roadside-card-number").keydown(function () {
    $("#ra-card-number-error").hide();
    this.style.backgroundColor = "";
    //force user to validate card number again
    if ($('[name=ct_purchase_select]').val() != "No")
      $('[name=ct_purchase_select]').val("No").trigger('change');
  });

  $('.product-single__price-current').bind("DOMSubtreeModified", function (e) {
    $('#total_price').text("CAD " + $(this).text());
  });

  //member check
  $('input[name="ra-member-rd"]').change(function () {
    console.log('test');
    $("#roadside-member-number").val('');
    $("#ra-card-number-error").hide();
    document.getElementById("roadside-member-number").style.backgroundColor = "";
    if (this.value == 'Yes') {
      $("#member-wrap").show();
      $("#roadside-member-number").prop('disabled', false);
      $("#roadside-member-number").prop('required', true);
    } else if (this.value == 'No') {
      $("#member-wrap").hide();
      $("#roadside-member-number").prop('disabled', true);
      $("#roadside-member-number").prop('required', false);
    }
  });

  function checkCardNumber(cnumber) {
    var fmt = /^6272249\d{9}$/;
    return fmt.test(cnumber);
  }

  function ctSetElementRequired(elms, show) {
    var i;
    for (i = 0; i < elms.length; i++) {
      if (show) {
        elms[i].disabled = false;
      } else {
        elms[i].disabled = true;
      }
    }
  }

  function processVerifyCard() {

    var qtyObj = $('[name=ct_plan_members]');
    var card = $("#roadside-card-number");
    var ret = true;

    $("#ra-card-number-error").hide();
    //card.removeClass("err-bg-color");
    document.getElementById("roadside-card-number").style.backgroundColor = "";
    if (card.val().length == 16 && checkCardNumber(card.val())) {
      $('[name=ct_purchase_select]').val("Yes").trigger('change');
      //qtyObj.val("1").trigger('change');

      if ($('input[name="ra-card-rd"]:checked').val() != "Yes")
        $("input[name='ra-card-rd'][value='Yes']").prop('checked', true);

    } else {
      ret = false;
      if (card.val().length == 0)
        $("#ra-card-number-error").html(ra_lang_rc.input_plan_number);
      else
        $("#ra-card-number-error").html(ra_lang_rc.invalid_plan_number);

      $("#ra-card-number-error").show();
      if ($('[name=ct_purchase_select]').val() != "No")
        $('[name=ct_purchase_select]').val("No").trigger('change');
      //document.getElementById("roadside-card-number").classList.add("err-bg-color");
      document.getElementById("roadside-card-number").style.backgroundColor = err_bg_color;
    }

    return ret;
  }

  function ctCheckInput(elm) {
    var err = "";
    var yearFmt = /^\d{4}$/; //Year	
    var colorFmt = /^[a-zA-Z]+$/; //alphabetic only
    var phoneFmt = /^[0-9\-\s]+$/; //number plus space and dash
    var emailFmt = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; //number plus space and dash
    var triangleFmt = /^\d{10}$/; //10 digits 
    var otherFmt = /^[a-zA-Z0-9\-_\.\s#]+$/; //others: alphanumeric, plus -,_,.,space,#

    var elm_name = elm.dataset.title.substr(0, 4).toLowerCase();
    if (elm_name == 'year' || elm_name == 'anné') { //vehicle Year, Year of Birth
      if (!yearFmt.test(elm.value))
        err = ra_lang_rc.year_4_digits;
    } else if (elm_name == 'colo' || elm_name == 'coul') { //vehicle Color
      if (!colorFmt.test(elm.value))
        err = ra_lang_rc.RC_err_color_is_alphabetic;
    } else if (elm_name == 'phon' || elm_name == 'télé') { //phone
      if (!phoneFmt.test(elm.value))
        err = ra_lang_rc.invalid_phone;
    } else if (elm_name == 'emai' || elm_name == 'cour') { //email
      if (!emailFmt.test(elm.value))
        err = ra_lang_rc.invalid_email;
    } else if (elm_name == 'tria' || elm.dataset.title == 'Carte de Fidélité Triangle') { //Triangle Reward #
      if (!triangleFmt.test(elm.value))
        err = ra_lang_rc.invalid_triangle_number;
    } else {
      if (!otherFmt.test(elm.value))
        err = ra_lang_rc.alphanumeric_only;
    }

    return err;
  }

  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    dataType: 'json',
    success: function () {}
  });

  //fixed issue: activate-now=>"purchased card" set to "No"=>Purchase=>click "back" from the Browser menu
  if ($('input[name="ra-card-rd"]:checked').val() != "Yes" && $('#roadside-card-number').is(':disabled') == false) {
    $("#checkcard-wrap").hide();
    $("#roadside-card-number").prop('disabled', true);
    $("#roadside-card-number").prop('required', false);
    if ($('[name=ct_purchase_select]').val() != "No")
      $('[name=ct_purchase_select]').val("No").trigger('change');
  }

  $(".ra-member-info-bar-ex").on("click", function (e) {
    var obj = this.querySelector(".addition-member-icon");
    $.each($('.addition-member-icon'), function (index, value) {
      var target = $("#" + $(this).data("targetid"));
      var iconPlus = $(this).find(".ra-icon-plus");
      var iconMinus = $(this).find(".ra-icon-minus");

      if ($(this).data("targetid") == obj.dataset.targetid) {
        if (iconPlus.hasClass("ra-display-none")) {
          iconPlus.removeClass("ra-display-none");
          iconMinus.addClass("ra-display-none");

          $(this).parents(".extra_member_info").addClass("border-bottom-none");
          $(this).parents(".ra-member-info-bar").removeClass("ra-bar-bg-color");
          var targetid = $(this).data("targetid");
          target.hide();
        } else {
          iconPlus.addClass("ra-display-none");
          iconMinus.removeClass("ra-display-none");

          $(this).parents(".extra_member_info").removeClass("border-bottom-none");
          $(this).parents(".ra-member-info-bar").addClass("ra-bar-bg-color");
          target.show();
        }
      } else if (iconPlus.hasClass("ra-display-none")) {
        iconPlus.removeClass("ra-display-none");
        iconMinus.addClass("ra-display-none");

        $(this).parents(".extra_member_info").addClass("border-bottom-none");
        $(this).parents(".ra-member-info-bar").removeClass("ra-bar-bg-color");
        var targetid = $(this).data("targetid");
        target.hide();
      }
    });
  });

});